import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgGoogle = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 25 24"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#4285F4"
      d="M24.358 12.265c0-.987-.081-1.706-.257-2.453H12.672v4.453h6.709c-.136 1.106-.866 2.773-2.489 3.892l-.023.15 3.614 2.759.25.024c2.3-2.093 3.625-5.172 3.625-8.825"
    />
    <path
      fill="#34A853"
      d="M12.672 23.997c3.287 0 6.046-1.067 8.061-2.906l-3.841-2.933c-1.028.706-2.407 1.2-4.22 1.2-3.219 0-5.95-2.093-6.924-4.986l-.143.011-3.758 2.867-.049.134a12.18 12.18 0 0 0 10.874 6.613"
    />
    <path
      fill="#FBBC05"
      d="M5.748 14.372a7.3 7.3 0 0 1-.406-2.373c0-.827.149-1.627.392-2.373l-.007-.16-3.804-2.912-.125.059A11.9 11.9 0 0 0 .5 11.999c0 1.933.473 3.759 1.298 5.385z"
    />
    <path
      fill="#EB4335"
      d="M12.672 4.64c2.286 0 3.828.973 4.707 1.786l3.435-3.306C18.704 1.187 15.96 0 12.672 0 7.912 0 3.8 2.693 1.798 6.612l3.936 3.013c.987-2.893 3.72-4.986 6.938-4.986"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGoogle);
const Memo = memo(ForwardRef);
export default Memo;
